export default "__VITE_ASSET__okwqbEPT__"